import sliceCreator from '../../index.jsx';
import {UPDATE_SALES_TARGET} from '../../../constants/index.jsx';
const _updateSalesTargetAction = sliceCreator('UPDATE_SALES_TARGET', UPDATE_SALES_TARGET, 'put');

const { asyncAction: updateSalesTargetAction, reducer, clearData: clearUpdateSalesTargetAction } = _updateSalesTargetAction;

export default reducer;

export {
    updateSalesTargetAction,
    clearUpdateSalesTargetAction
}